import {
    defaultProcessArtifactResource,
    useProcessArtifactActions,
} from '../../../../resource/resources/artifacts/process_artifact/processArtifactResource';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import { OpenModal } from '../../../../../../react-commons/utils/modals/openModal';
import {
    defaultProcessAreaProcessArtifactAssociationResource,
    useProcessAreaProcessArtifactAssociationActions,
} from '../../../../resource/resources/artifacts/process_area/processAreaProcessArtifactAssociationResource';
import { StackedCardsComponent } from '../../../reusable-components/StackedCardsComponent';
import { useDeleteResourceDialogFunction } from '../../../reusable-components/dialogs/UseDeleteResourceDialogFunction';
import React from 'react';
import { ProcessArtifactEditDialog } from '../../project/reusable-elements/process-artifact/ProcessArtifactEditDialog';
import { useNestedDialogFunction } from '../../../../../../react-commons/dialog-provider/UseNestedDialogFunction';
import { ProcessArtifactDirection } from '../../../../resource/enumerations/ProcessArtifactDirection';
import { formatIdentifier } from '../../../../../../react-commons/utils/utilFunctions';

export const StackedProcessArtifactsView = ({isAdmin, processAreaId, versionId, direction, link}: {
    isAdmin: boolean,
    processAreaId: string | undefined,
    versionId: string | undefined,
    direction: ProcessArtifactDirection,
    link: string | undefined
}) => {

    const nestedDialog = useNestedDialogFunction();
    const deleteResourceDialogFunction = useDeleteResourceDialogFunction();

    const processArtifactAssociationActions = useProcessAreaProcessArtifactAssociationActions();
    const processArtifactActions = useProcessArtifactActions();
    const processArtifactAssociationsQuery = processArtifactAssociationActions.useGetAllResources(processAreaId)
    const processArtifactsQuery = processArtifactActions.useGetAllResources(versionId);

    const deleteProcessArtifactAssociation = processArtifactAssociationActions.useDeleteResource();
    const addProcessArtifactAssociation = processArtifactAssociationActions.useAddResource();
    const addProcessArtifact = processArtifactActions.useAddResource();

    const getProcessArtifactAssociationFilteredByDirection = () => processArtifactAssociationsQuery.data?.filter(value => value.direction === direction) ?? []

    const addAssociation = () => OpenModal.SelectionOrCreateModal(
        "Select or Create a Process Artifact",
        processArtifactsQuery.data?.filter(processArtifact =>
            !(getProcessArtifactAssociationFilteredByDirection().some(association => association.processArtifact === processArtifact.objectId)))
            .map(processArtifact => ({label: processArtifact.name, value: processArtifact.objectId})) ?? [],
        true,
        null,
        async (value) => {
            if (value && processAreaId) {
                await addProcessArtifactAssociation.mutateAsync({
                    resource: {
                        ...defaultProcessAreaProcessArtifactAssociationResource,
                        processArtifact: value,
                        direction
                    },
                    parentId: processAreaId
                })
            }
        },
        async (value, multiLineValue) => {
            if (value && processAreaId && versionId) {
                await addProcessArtifact.mutateAsync({
                        resource: {
                            ...defaultProcessArtifactResource,
                            name: value,
                            description: multiLineValue ?? ""
                        },
                        parentId: versionId
                    },
                    {
                        onSuccess: (result) => {
                            const processArtifactObjectId = result?.content?.objectId
                            if (processArtifactObjectId) {
                                addProcessArtifactAssociation.mutateAsync({
                                    resource: {
                                        ...defaultProcessAreaProcessArtifactAssociationResource,
                                        processArtifact: processArtifactObjectId,
                                        direction
                                    },
                                    parentId: processAreaId
                                })
                            }
                        },
                    }
                )
            }
        },
        undefined,
        "Name",
        true,
        "Description",
        800
    )

    const onDelete = (id: string) => {
        deleteResourceDialogFunction.deleteResource(
            id, null, ResourceType.PROCESS_AREA_PROCESS_ARTIFACT_ASSOCIATION, deleteProcessArtifactAssociation
        )
    }

    const onEdit = (id: string) => {
        const association = getProcessArtifactAssociationFilteredByDirection().find(value => value.id === id)
        if (association) {
            nestedDialog.showNestedDialog(
                <ProcessArtifactEditDialog
                    onClose={nestedDialog.closeNestedDialog}
                    objectId={association.processArtifact}
                    versionedInId={versionId ?? ""}
                />
            );
        }
    }

    return (
        <StackedCardsComponent
            title={`${formatIdentifier(direction)} Process Artifact`}
            data={getProcessArtifactAssociationFilteredByDirection().map(value => ({
                id: value.id,
                text: processArtifactsQuery.data?.find(resource => resource.objectId === value.processArtifact)?.name ?? "",
                description: processArtifactsQuery.data?.find(resource => resource.objectId === value.processArtifact)?.description ?? "",
                img: null
            })) ?? []}
            onAdd={isAdmin ? addAssociation : undefined}
            onDelete={isAdmin ? onDelete : undefined}
            onEdit={isAdmin ? onEdit : undefined}
            link={link}
            section={direction === ProcessArtifactDirection.INPUT ? "inputs" : "outputs"}
        />
    );
};